module.exports = __webpack_public_path__ + "img/qq.b67654a8.svg";